export interface ChangePassword {
  $id: string;
  employeeId?: string;
  newPasswordA: string;
  newPasswordB: string;
  oldPassword: string;
}
